import { createContext, useCallback, useContext, useMemo, useState } from "react";

const STORAGE_KEY = "aktos:redesignPreview";

const RedesignPreviewContext = createContext(undefined);
RedesignPreviewContext.displayName = "RedesignPreviewContext";

function loadRedesignPreview() {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored === "true";
  } catch {
    return false;
  }
}

function CompactModeProvider({ children }) {
  const [isCompactMode, setIsCompactMode] = useState(loadRedesignPreview);

  const toggleCompactMode = useCallback(() => {
    setIsCompactMode((prev) => {
      const next = !prev;
      try {
        localStorage.setItem(STORAGE_KEY, String(next));
      } catch {
        // Silently ignore localStorage errors
      }
      return next;
    });
  }, []);

  const value = useMemo(
    () => ({ isCompactMode, toggleCompactMode }),
    [isCompactMode, toggleCompactMode],
  );

  return (
    <RedesignPreviewContext.Provider value={value}>{children}</RedesignPreviewContext.Provider>
  );
}

export default CompactModeProvider;

export function useCompactMode() {
  const context = useContext(RedesignPreviewContext);
  if (context === undefined) {
    throw new Error("useCompactMode must be used within a CompactModeProvider");
  }
  return context;
}
